import { render, staticRenderFns } from "./ProductMapping.vue?vue&type=template&id=28429ed7&scoped=true"
import script from "./ProductMapping.vue?vue&type=script&lang=js"
export * from "./ProductMapping.vue?vue&type=script&lang=js"
import style0 from "./ProductMapping.vue?vue&type=style&index=0&id=28429ed7&prod&scoped=true&lang=css"
import style1 from "./ProductMapping.vue?vue&type=style&index=1&id=28429ed7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28429ed7",
  null
  
)

export default component.exports